import { formatDistanceToNow, formatDistanceToNowStrict, parse } from 'date-fns';
import { condencedDateLocale } from "./condencedDateLocale";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ContractExpires = _ref => {
  let {
    contract,
    variant = 'default'
  } = _ref;
  const formatFn = variant === 'condenced' ? formatDistanceToNowStrict : formatDistanceToNow;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: formatFn(parse(contract.endDate, 'yyyy-MM-dd', new Date()), {
      addSuffix: true,
      locale: variant === 'condenced' ? condencedDateLocale : undefined
    })
  });
};